import * as Tokens from '@atlaskit/tokens';
import TokenNames from '@atlaskit/tokens/token-names';
import globalize from '../internal/globalize';



const testingColorVariableName = '--aui-theme-testing-color';
const defaultTestingColor = 'color(srgb 1 0.75 0.8 / 0.6)';
const testingThemeName = 'aui-theme-testing';

/**
 * Theme that replaces all the design tokens with single color, helping to visually identify custom colors on the page
 *
 * @param solidColor any valid CSS color, will be used to replace tokens
 */
(function generateTestingTheme() {

    const initialComment = 'This theme is autogenerated using AJS.DesignTokens.generateTestingTheme().'

    // If function called many times theme should be only added once
    const isThemeAlreadyInitialised = !document.getElementById(testingThemeName)
    if (!isThemeAlreadyInitialised) {
        return;
    }

    // We use overridable test color declaration to make theme configurable
    const colorDeclaration = `${testingColorVariableName}: ${defaultTestingColor};`
    const themeCSSDeclarations = Object.values(TokenNames)
        .map(token => `\t${token}: var(${testingColorVariableName});`);
    const allDeclarations = [colorDeclaration, ...themeCSSDeclarations];


    const themeCSS = `/* ${initialComment} */\nbody.${testingThemeName} {\n${allDeclarations.join('\n')}\n}`;

    const themeElement = document.createElement('style');
    themeElement.id = testingThemeName;
    themeElement.innerText = themeCSS;

    const head = document.querySelector('head');
    if (head) {
        head.appendChild(themeElement);
    }
}());


/**
 * Enables or disables testing theme for Design Tokens based on current state
 * @param state Optional parameter. Allows to force specific state.
 */
export function toggleTestingTheme(state) {

    // If not passed, invert existing state
    if (state == null) {
        const currentState = document.body.classList.contains(testingThemeName);
        state = !currentState;
    }

    state ? enableTestingTheme() : disableTestingTheme();
}

/**
 * Overrides default testing color by setting css variable. If no color passed, will revert to default.
 * @param color color to use for testing
 */
export function setTestingThemeColor(color = defaultTestingColor) {
    document.body.style.setProperty(testingColorVariableName, color);
}

export function enableTestingTheme() {
    const isEnabled = document.body.classList.contains(testingThemeName);
    if (!isEnabled) {
        document.body.classList.add(testingThemeName);
    }
}

export function disableTestingTheme() {
    const isEnabled = document.body.classList.contains(testingThemeName);
    if (isEnabled) {
        document.body.classList.remove(testingThemeName);
        document.body.style.removeProperty(testingColorVariableName);
    }
}

// Export for NPM bundle, for which Webpack automatically puts those functions under AJS.DesignTokens
export const {
    setGlobalTheme,
    token,
    themeObjectToString,
    themeStringToObject,
    getTokenValue
} = Tokens;

// Export for p2-plugin bundle, where we need to do put those functions under AJS.DesignTokens manually
globalize('DesignTokens', {
    setGlobalTheme,
    token,
    themeObjectToString,
    themeStringToObject,
    getTokenValue,
    toggleTestingTheme,
    enableTestingTheme,
    disableTestingTheme,
    setTestingThemeColor
});
